<template>
  <div>
    <main>
      <v-container fluid grid-list-xl class="content-header">
        <v-flex xs12 sm10 offset-sm1>
          <v-layout row class="flex-row">
            <div>
              <h3 class="headline mb-0">UPCOMING EVENT - {{event.name}}</h3>
              <span>{{event.start}} - {{getType(event.type)}}</span>
            </div>
          </v-layout>
        </v-flex>
        <v-flex grid-list-md xs12 sm10 offset-sm1 class="grid-adjustment">
          <v-layout row wrap>
            <v-flex xs12 md6 lg3 class="layout-padding" v-for="(message, index) in messages" :key="index">
              <router-link tag="div" :to="{ name: 'messageConfig', params: { id: message._id } }">
                <div class="single-message">
                  <v-card-title class="message-title">{{message.section.name}}<v-icon color="primary" class="tv-icon">tv</v-icon></v-card-title>
                  <div class="message-img">
                    <img draggable="false" :src="`${baseUrl}${message.thumbnail}?${Date.now()}`">
                  </div>
                  <v-btn fab dark small color="accent" @click.stop.prevent="openDelete(message._id, index)">
                    <v-icon dark>close</v-icon>
                  </v-btn>
                </div>
              </router-link>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-container>
    </main>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <delete-modal modalType="Message" path="message" :id="deleteId" v-if="dialogDelete" @close="dialogDelete = false" @submit="submitDelete"></delete-modal>
    </v-dialog>
  </div>
</template>

<script>
  import webHelper from '../../helpers/web';
  import Delete from '../modals/Delete';

  export default {
    data: () => ({
      event: {},
      messages: [],
      baseUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : '/',
      dialogDelete: false,
      deleteId: null,
      deleteIndex: null,
    }),
    methods: {
      getType(type) {
        switch (parseInt(type, 10)) {
          case 0:
            return 'NFL';
          case 1:
            return 'NCAA';
          case 2:
          default:
            return 'Other';
        }
      },
      openDelete(id, index) {
        this.deleteId = id;
        this.deleteIndex = index;
        this.dialogDelete = true;
      },
      submitDelete() {
        this.messages.splice(this.deleteIndex, 1);
        this.deleteId = null;
        this.deleteIndex = null;
        this.dialogDelete = false;
      },
    },
    components: {
      deleteModal: Delete,
    },
    async created() {
      const res = await webHelper.get(this, 'event/current');
      if (res.failed) {
        this.err = 'Failed to get the Event.';
        return;
      }
      const res2 = await webHelper.get(this, 'message', { events: res.event._id });
      this.event = res.event;
      this.messages = res2.messages;
    },
  };
</script>

<style scoped lang="scss">
  h3 {
    font-weight: 700;
  }
  main {
    padding-top: 64px;
  }
  .grid-adjustment {
    margin-top: 20px;
  }
  .layout-padding {
    padding: 0 7%;
  }
  .single-message {
    position: relative;
    margin: 10px auto;
    padding: 0 20px 20px 20px !important;
    background-color: #f1f1f1;
    border: 1px solid rgba(0,0,0, 0.12);
    .message-title {
      padding: 15px 0 30px 0; 
    }
    .message-img {
      max-width: 80%;
      margin: 0 auto;
      overflow: hidden;
      height: auto;
      padding-top: 60%;
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        height: auto;
      }
    }
    .tv-icon {
      margin-left: auto;
      right: 20px;
    }
    button {
      position: absolute;
      right: -25px;
      bottom: -15px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/messages/CurrentEvent.vue